import React from "react";
import logo from "../assets/images/logo.png";

export default function AccessDenied({ onLogin }) {
  return (
    <div className="bt-auth-page">
      <div className="bt-auth-card">
        <img src={logo} alt="OPOS Logo" className="bt-auth-logo" />
        <h2 className="bt-auth-title">Access Denied</h2>
        <p className="bt-auth-message">
          You are not authenticated to use the Application.
          <br />
          Please login to continue.
        </p>
        <button type="button" className="bt-btn bt-btn-primary" onClick={onLogin}>
          Login
        </button>
      </div>
      <p className="bt-auth-footer">© 2026, OPOS, Inc. All Rights Reserved</p>
    </div>
  );
}
